export const OVERVIEW_TABS = [
  { value: "tickets", title: "Tickets" },
  { value: "rates", title: "Rates" },
  { value: "profile", title: "Profile" },
  { value: "integration", title: "Integrasi" },
];
